export default __webpack_public_path__ + "static/media/pert.cb1881c3.png";